<div id="chart" #chart>
  @if (displayChart) {
    <canvas
      #chart="base-chart"
      baseChart
      [datasets]="data"
      [options]="options"
      [labels]="labels"
      [type]="type"
    ></canvas>
  } @else {
    <img [src]="displayImage" />
    <div #resizeContainer class="resize-container">
      <canvas
        #chart="base-chart"
        baseChart
        [datasets]="data"
        [options]="options"
        [labels]="labels"
        [type]="type"
      ></canvas>
    </div>
  }
</div>
